import s from './WhyTronLink.module.scss'
import React from 'react'
import {
    EyeInvisibleOutlined,
    KeyOutlined,
    SafetyOutlined,
    SafetyCertificateOutlined,
    CheckCircleOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons'
import { useLanguage } from 'context/LanguageContext'
import { whyTronLinkContent } from './whyTronLink.content'

// Иконки по порядку пунктов (конфиденциальность → ключи → депозиты →
// фишинг-стойкий вход → доверие).
const ICONS = [
    EyeInvisibleOutlined,
    KeyOutlined,
    SafetyOutlined,
    SafetyCertificateOutlined,
    CheckCircleOutlined,
]

interface Props {
    /** Скрыть крупный заголовок (когда он уже есть снаружи, напр. в Collapse). */
    hideTitle?: boolean
    className?: string
}

/** Объяснение ценности регистрации через TronLink — конфиденциальность и
 *  безопасность депозитов.  Единый контент для формы регистрации и гайда. */
export const WhyTronLink: React.FC<Props> = React.memo(
    ({ hideTitle, className }) => {
        const { language } = useLanguage()
        const c = whyTronLinkContent[language] ?? whyTronLinkContent['en']

        return (
            <div className={[s.wrapper, className].filter(Boolean).join(' ')}>
                {!hideTitle && <h3 className={s.title}>{c.title}</h3>}

                <p className={s.intro}>{c.intro}</p>

                <ul className={s.points}>
                    {c.points.map((p, i) => {
                        const Icon = ICONS[i] ?? CheckCircleOutlined
                        return (
                            <li className={s.point} key={i}>
                                <span className={s.pointIcon}>
                                    <Icon />
                                </span>
                                <span className={s.pointBody}>
                                    <span className={s.pointTitle}>
                                        {p.title}
                                    </span>
                                    <span className={s.pointText}>
                                        {p.text}
                                    </span>
                                </span>
                            </li>
                        )
                    })}
                </ul>

                <div className={s.note}>
                    <InfoCircleOutlined className={s.noteIcon} />
                    <span>{c.note}</span>
                </div>
            </div>
        )
    }
)
